import { useMemo } from "react";
import { initials } from "./meetingsUtils";

/**
 * SellerAvatar — círculo con iniciales del vendedor (P3).
 *
 * El color se deriva determinísticamente del id (hash → HSL) para que
 * Alonso siempre se vea verde, Oscar siempre azul, etc. Sin necesidad
 * de columna `color` en la tabla `sales`.
 */
function colorFromId(id: string | number): string {
  const str = String(id);
  let h = 0;
  for (let i = 0; i < str.length; i++)
    h = (h * 31 + str.charCodeAt(i)) >>> 0;
  // Hue 0..360, pero excluimos rangos amarillo (40-65) para no chocar con accent
  const hue = (h % 280) + 80; // 80..360
  return `hsl(${hue}, 55%, 70%)`;
}

export function SellerAvatar({
  id,
  name,
  size = 28,
  ring,
  imageUrl,
}: {
  id: string | number;
  name?: string | null;
  size?: number;
  ring?: string;
  imageUrl?: string | null;
}) {
  const ini = useMemo(() => initials(name || String(id)), [name, id]);
  const bg = useMemo(() => colorFromId(id), [id]);
  const style: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius: "50%",
    background: imageUrl ? "transparent" : bg,
    color: "#1a1a1a",
    fontSize: size * 0.42,
    fontWeight: 700,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: ring ? `0 0 0 2px ${ring}` : "none",
    fontFamily: "inherit",
    letterSpacing: "-0.02em",
    overflow: "hidden",
    flex: "0 0 auto",
  };
  return (
    <div title={name || String(id)} style={style} aria-label={name || String(id)}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={name || ""}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        ini
      )}
    </div>
  );
}
